import React from 'react'
import { SVGProps } from 'react'

const RoomIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 1h10a.8.8 0 0 1 .8.8V15h-2.2V3.2H4.4V15H2.2V1.8A.8.8 0 0 1 3 1Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.4 4.2h5.2V15H5.4V4.2Zm3.9 4.2a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Z"
    />
  </svg>
)
export default RoomIcon
